<template>
	<div class="navbar carkpig2">
		<!-- <hamburger
			id="hamburger-container"
			:is-active="sidebar.opened"
			class="hamburger-container"
			@toggleClick="toggleSideBar"
		/> -->
		<!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
		<span class="icon iconfont icon-caidan iconss"></span>
		<span class="title-container">服务平台</span>
		<span class="menuIcon">
			<span class="icon iconfont icon-shouye1-copy iconss" style="cursor:pointer;" @click="openhome"></span>
			<span class="title-container" @click="gzmb">工作面板</span>
			<span class="title-container" @click="rcap">日程安排</span>
		</span>
		<div class="right-menu">
			<!-- <template v-if="device !== 'mobile'"> -->
				<!-- <search id='header-search' class='right-menu-item' /> -->
				<!-- <error-log class='errLog-container right-menu-item hover-effect' /> -->
				<!-- <el-select
					v-model="brandId"
					@change="selectChange"
					class="autowidth-select"
				>
					<template slot="prefix">
						<div class="brandImg">
							<img
								v-if="!brandLogo"
								src="../../assets/default-logo.png"
								class="band-logo"
							/>
							<img v-else :src="brandLogo" class="brand-logo" />
							{{ (bandInfo.find((s) => s.id === brandId) || {}).label }}
						</div>
					</template>
					<el-option
						class="brandOption"
						v-for="item in bandInfo"
						:key="item.id"
						:label="item.brandName"
						:value="item.id"
					>
						<template>
							<div class="brandImg">
								<img :src="item.brandLogo" class="brand-logo" />
								<div class="name">{{ item.brandName }}</div>
							</div>
						</template>
					</el-option>
				</el-select> -->

				<!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->

				<!--        <el-tooltip content='字体大小' effect='dark' placement='bottom'>-->
				<!--          <size-select id='size-select' class='right-menu-item hover-effect'/>-->
				<!--        </el-tooltip>-->
				<!--        <el-tooltip content="更换主题" effect="dark" placement="bottom">-->
				<!--          <theme-picker id="theme-picker" class="right-menu-item hover-effect" />-->
				<!--        </el-tooltip>-->
			<!-- </template> -->

			<el-dropdown
				class="avatar-container right-menu-item hover-effect"
				trigger="click"
			>
				<div class="avatar-wrapper">
					<img :src="logo" class="user-avatar" />
					<i class="el-icon-caret-bottom"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item @click.native="indevInfo"
						>个人信息</el-dropdown-item
					>
					<el-dropdown-item @click.native="editInfo">修改信息</el-dropdown-item>
					<router-link to="/">
						<el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
					</router-link>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div>
			<infoDrawer
				ref="indevInfo"
				v-if="selfList"
				:selfList="selfList"
			></infoDrawer>
			<editInfoDrawer ref="editInfo" @getHeadimgurl="getHeadimgurl" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import ThemePicker from '@/components/ThemePicker'
import Search from '@/components/HeaderSearch'
import infoDrawer from '@/components/InfoDrawer/personinfo.vue'
import editInfoDrawer from '@/components/InfoDrawer/editPersonInfo.vue'
import { loginOut } from '@/api/login.js'
import { removeToken } from '@/utils/auth'
import { getBrandLists, switchBrand } from '@/api/brand.js'
import { getSelfData } from '@/api/stafflist.js'
import localforage from 'localforage'

export default {
	 components: {
	 	Breadcrumb,
	 	Hamburger,
	 	ErrorLog,
	 	Screenfull,
	 	SizeSelect,
	 	infoDrawer,
	 	editInfoDrawer,
	 	Search,
	 	ThemePicker
	 },
	data() {
		return {
			//indevInfo: false,
			changeInfo: false,
			logo: require('@/assets/default-avatar.png'),
			bandInfo: [],
			brandLogo: '',
			brandId: '',
			selfList: null,

			messages: [],
			eventSource: null
		}
	},
	computed: {
		// ...mapGetters(['sidebar', 'avatar', 'device'])
	},

	mounted() {
		// this.logo = localStorage.getItem('headimg')
		this.getSelfData()
		this.getBrandList()
	},
	methods: {
		gzmb() { 
			this.$router.push({ path: '/homeEditor/homeEditor' })
		},
		rcap() { 
			this.$router.push({ path: '/FullCalendar/FullCalendar' })
		},
		openhome(){
			this.$router.push({ path: '/homePage/homePage' })
		},
		// 微信绑定成功后刷新头像
		getHeadimgurl(e) {
			this.logo = e
		},
		// 获取个人信息
		getSelfData() {
			 getSelfData().then((res) => {
			 	if (res && res.status === 200000) {
			 		this.selfList = res.data ? res.data : []
			 		const headimg = res.data.headimg
			 		this.logo = headimg
			 		localStorage.setItem('headimg', headimg)
			 		this.$store.commit(
			 			'readChatStatus/SET_READCHATSTATUS',
			 			res.data.remindStatus
			 		) 
			 		// console.log('红点----------', res.data.remindStatus)
			 	}
			 })
		},
		// 获取当前品牌列表
		async getBrandList() {
			// const res = await getBrandLists()
			// getBrandLists().then((res) => {
			// 	if (res.status === 200000) {
			// 		this.bandInfo = res.data
			// 		if (this.bandInfo && this.bandInfo.length > 0) {
			// 			this.bandInfo.forEach((item) => {
			// 				if (item.isSelect == 1) {
			// 					this.brandLogo = item.brandLogo
			// 					this.brandId = item.id
			// 				}
			// 			})
			// 		}
			// 	}
			// })
		},
		// 选择品牌
		async selectChange(e) {
			const res = await switchBrand({ id: e })
			if (res.status === 200000) {
				this.$message.success('切换品牌成功！')
				this.$router.go(0)
			}
		},

		indevInfo() {
			this.$refs.indevInfo.drawerState = true
		},
		editInfo() {
			this.$refs.editInfo.drawerState = true
		},
		toggleSideBar() {
			this.$store.dispatch('app/toggleSideBar')
		},

		// 退出登录
		async logout() {
			const result = await this.$store.dispatch('user/logout')
			// if (result.status === 200000) {}
			localStorage.removeItem('headimg')
			// this.$router.push({ path: '/login' })
			localforage.clear()
			// loginOut().then((dataS) => {
			//   if (dataS.status == '200000') {
			//     // 清除缓存
			//     removeToken()
			//     // // 销毁状态
			//     localStorage.removeItem('status')
			//     // 清除所有缓存
			//     // let storage = window.localStorage;
			//     //   storage.clear()
			//     // // 跳转至登录页
			//     this.$router.push({ path: '/login' })
			//   } else {
			//     this.$message.success(dataS.describe)
			//   }
			// })

			// if (dataS.status !== '200000') {
			//   this.$message.error(dataS.describe)
			//   return
			// } else {
			//   this.$message.success('退出成功~')
			// }

			// this.$router.push(`/login?redirect=${this.$route.fullPath}`)
		}
	}
}
</script>

<style lang='scss' scoped>
.menuIcon{
	margin-left: 20%;
}
.iconss{
	font-size: 23px;
    margin: 0px 20px;
    color: #fff;
}
.title-container{
    color: #fff;
    font-weight: 700;
	margin: 0px 10px;
	cursor:pointer;
}
.brandOption {
	height: 45px;
	line-height: 45px;
}

.brandImg {
	display: flex;
	margin-top: 10px;
	width: 30px;
	height: 30px;

	.brand-logo {
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}

	.name {
		height: 30px;
		line-height: 30px;
		padding-left: 5px;
	}
}

.autowidth-select {
	min-width: 140px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.navbar {
	line-height: 50px;
	height: 50px;
	overflow: hidden;
	position: relative;
	background: #4a5bc9;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
	z-index: 999;
	.right-menu {
		::v-deep .el-input--medium .el-input__inner {
			border: none;
			margin-right: 5px;
			position: absolute;
			width: 100%;
			text-align: center;
		}
	}

	::v-deep .el-select {
		top: -5px;
	}

	::v-deep .el-input__prefix {
		// left: -2px;
		position: relative;
	}

	::v-deep .el-input__suffix {
		top: -10px;
	}

	.hamburger-container {
		line-height: 46px;
		height: 100%;
		float: left;
		cursor: pointer;
		transition: background 0.3s;
		-webkit-tap-highlight-color: transparent;

		&:hover {
			background: rgba(0, 0, 0, 0.025);
		}
	}

	.breadcrumb-container {
		float: left;
	}

	.errLog-container {
		display: inline-block;
		vertical-align: top;
	}

	.right-menu {
		float: right;
		height: 100%;
		line-height: 50px;

		&:focus {
			outline: none;
		}

		.right-menu-item {
			display: inline-block;
			padding: 0 8px;
			height: 100%;
			font-size: 18px;
			color: #5a5e66;
			vertical-align: text-bottom;

			&.hover-effect {
				cursor: pointer;
				transition: background 0.3s;

				&:hover {
					background: rgba(0, 0, 0, 0.025);
				}
			}
		}

		.avatar-container {
			margin-right: 30px;

			.avatar-wrapper {
				margin-top: 10px;
				position: relative;

				.user-avatar {
					cursor: pointer;
					width: 30px;
					height: 30px;
					border-radius: 50px;
					object-fit: cover;
				}

				.el-icon-caret-bottom {
					cursor: pointer;
					position: absolute;
					right: -20px;
					top: 12px;
					color: #fff;
					font-size: 12px;
				}
			}
		}
	}
}
</style>
